import styled from "styled-components";

export const EventScheduleWrapper = styled.div<{
  isApp: number | null;
}>`
  padding-top: ${(p) => (p.isApp ? `${p.isApp}px` : "0px")};
  width: 100%;
  height: 100vh;
  overflow: auto;
`;

export const EventScheduleHeader = styled.div<{
  isApp: number | null;
}>`
  position: relative;
  width: 100%;
  top: ${(p) => (p.isApp ? `-${p.isApp}px` : "0px")};

  > .banner {
    > img {
      width: 100%;
    }
  }

  > .title {
    position: absolute;
    bottom: 21px;
    left: 16px;

    color: #fff;
    font-family: Pretendard;
    font-size: 35px;
    font-style: normal;
    font-weight: 900;
    line-height: 40px; /* 114.286% */

    > span {
      color: #fff;
      font-family: Pretendard;
      font-size: 20px;
      font-style: normal;
      font-weight: 600;
      line-height: 40px;
    }
  }
`;

export const EventScheduleContentWrapper = styled.div<{
  isApp: number | null;
}>`
  margin-top: ${(p) => (p.isApp ? `-${p.isApp}px` : "0px")};
`;

export const EventScheduleTabWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 41px;

  > .tab {
    flex: 1;
    line-height: 41px;
    font-weight: 700;
    font-size: 16px;
    text-align: center;
    color: #a4a4a4;

    &.selected {
      color: var(--Black-400, #444444);
      border-bottom: 1px solid #000;
    }
  }
`;
